import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8b5d592"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main-navbar",
  class: "navbar navbar-expand-md navbar-dark bg-dark",
  "data-info": "https://www.codeply.com/p/P0KN7DNsEq"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler ms-auto",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#collapseNavbar"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_4 = {
  id: "collapseNavbar",
  class: "navbar-collapse collapse"
}
const _hoisted_5 = { class: "navbar-nav" }
const _hoisted_6 = { class: "navbar-nav ms-auto" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))

import AppRouterNavLink from "@/components/app/navigation/AppRouterNavLink.vue";
import AppIcon from "@/components/app/AppIcon.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import AppNavDropdown from "@/components/app/navigation/AppNavDropdown.vue";
import { useRouter } from "vue-router";
import { UserRole } from "@/store/modules/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavBar',
  setup(__props) {

const isDevelopment = process.env.NODE_ENV !== "production"

const store = useStore()
const router = useRouter()

const isAuthenticated = computed(() => store?.getters['auth/isAuthenticated'])
const hasAccessToAdmin = computed(() => store?.getters["auth/roles"].includes(UserRole.ACCESS_TO_ADMIN))
const isSilpoChequesCustomer = computed(() => store?.getters["auth/roles"].includes(UserRole.SILPO_CHEQUES_CUSTOMER))
const isSilpoProductsManager = computed(() => store?.getters["auth/roles"].includes(UserRole.SILPO_PRODUCTS_MANAGER))

function onSignOutClick () {
  store?.dispatch('auth/logout')
  router.push({ name: 'auth' })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand abs",
        to: {name: 'home'}
      }, {
        default: _withCtx(() => [
          _createTextVNode("Your calendar")
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppRouterNavLink, {
            to: {name: 'home'},
            "link-class": "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Home ")
            ]),
            _: 1
          }),
          _createVNode(AppRouterNavLink, {
            to: {name: 'plants-list'},
            "link-class": "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Plants ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_unref(isAuthenticated) && _unref(isSilpoChequesCustomer))
            ? (_openBlock(), _createBlock(AppNavDropdown, {
                key: 0,
                inverse: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Silpo ")
                ]),
                items: _withCtx(() => [
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'shopping-silpo-cheques'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cheques ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'shopping-silpo-statistic'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Statistic ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'shopping-silpo-products'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Products ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'shopping-silpo-products-search'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Products search ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'shopping-silpo-favourite-stores'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Favourite stores ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(AppNavDropdown, {
                key: 1,
                inverse: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Events ")
                ]),
                items: _withCtx(() => [
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'events-list'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Events ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'calendars-list'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Calendars ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(AppRouterNavLink, {
                key: 2,
                to: {name: 'reminders-list'},
                "link-class": "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Reminders ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isAuthenticated) && _unref(hasAccessToAdmin))
            ? (_openBlock(), _createBlock(AppNavDropdown, {
                key: 3,
                inverse: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Admin ")
                ]),
                items: _withCtx(() => [
                  (_unref(isSilpoProductsManager))
                    ? (_openBlock(), _createBlock(AppRouterNavLink, {
                        key: 0,
                        to: {name: 'shopping-silpo-manual-fix-uncategorized-products'},
                        "link-class": "dropdown-item"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Uncategorized products ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(AppNavDropdown, {
                key: 4,
                inverse: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, { icon: "user" })
                ]),
                items: _withCtx(() => [
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'cabinet-account-notifications'},
                    icon: "bell",
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Notifications ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'cabinet-settings'},
                    icon: "cog",
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Settings ")
                    ]),
                    _: 1
                  }),
                  _hoisted_7,
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item",
                      role: "button",
                      onClick: _withModifiers(onSignOutClick, ["prevent"])
                    }, [
                      _createVNode(AppIcon, {
                        icon: "sign-out-alt",
                        class: "route-nav-link-icon"
                      }),
                      _createTextVNode(" Sign out ")
                    ], 8, _hoisted_8)
                  ]),
                  (isDevelopment && _unref(isAuthenticated))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_9,
                        _createVNode(AppRouterNavLink, {
                          to: {name: 'playground'},
                          icon: "gamepad",
                          "link-class": "dropdown-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Play ")
                          ]),
                          _: 1
                        }),
                        _createVNode(AppRouterNavLink, {
                          to: {name: 'help'},
                          icon: "question",
                          "link-class": "dropdown-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Help ")
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(isAuthenticated))
            ? (_openBlock(), _createBlock(AppNavDropdown, {
                key: 5,
                inverse: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, { icon: "lock" })
                ]),
                items: _withCtx(() => [
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'signin'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sign in ")
                    ]),
                    _: 1
                  }),
                  _createVNode(AppRouterNavLink, {
                    to: {name: 'signup'},
                    "link-class": "dropdown-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sign up ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})